import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Transaction } from '../transaction/transaction';
import { ValidationInterface } from '../data';
import { ValidationRepository } from '../repositories/validation.repository';

@Injectable()
export class ValidationProvider {
    constructor(private validationRepository: ValidationRepository) {}

    update(validation: ValidationInterface): Observable<Transaction<void>> {
        return this.validationRepository.update(validation);
    }
}
